import { render, staticRenderFns } from "./sidebar-stripe.vue?vue&type=template&id=591a42ae&"
import script from "./sidebar-stripe.vue?vue&type=script&lang=js&"
export * from "./sidebar-stripe.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-stripe.vue?vue&type=style&index=0&id=591a42ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports